<!-- 商品详情页 -->
<template>
  <cc-container>
    <skeleton v-if="showSkeleton" />
    <template v-else>
      <cc-header-nav class="header" style="background:#fff;">
        <template slot="left">
        </template>
        <div slot="center">
          <div class="topTitle" style="opacity:0">
            <span
              v-for="(item,index) in topTitleCon"
              :key="index"
              :class="index===activeTitle? 'activeTitle':''"
              @click="tabTop(index)"
            >{{item.txt}}</span>
          </div>
        </div>
        <template slot="right">
          <div class="ellipsis">
            <van-icon
              class="ellipsis-icon"
              name="ellipsis"
              @click.stop="isShowSmallNav = !isShowSmallNav"
            />
          </div>
        </template>
      </cc-header-nav>

      <cc-main class="main" ref="contain">
        <cc-pull-refresh v-model="isLoading" @refresh="onRefresh" class="pull-refresh">
          <van-swipe @change="onChange" class="swipe">
            <van-swipe-item v-for="(item,index) in detailData.image" :key="index">
              <div class="swipe-item">
                <img
                  :src="item"
                  alt
                  v-errorImg="require(`@/assets/img/ungoodsphoto.png`)"
                  @click="showimgs(index)"
                />
                <span v-if="detailData.is_online_pay_goods"></span>
              </div>
            </van-swipe-item>
            <template #indicator>
              <p class="tips">温馨提示：图片仅供参考，请以实物为准</p>
              <div class="custom-indicator">{{ current + 1 +'/'+detailData.image_count}}</div>
            </template>
          </van-swipe>
          <!-- 限时秒杀 今日特价 满赠 预售-->
          <div class="gift-title" v-if="showActivityTxt(detailData)">
            <div class="gift-title-left">
              <p
                :style="{'height':((detailData.type===8&&!+detailData.payment_type)||detailData.type==5)||isNaN(detailData.jiage)?'100%':'0.3rem'}"
              >
                <span class="f18">
                  <span
                    class="f12"
                  >{{showprice(detailData.type===8&&+detailData.payment_type?detailData.deposit:detailData.jiage)}}</span>
                  {{detailData.type===8&&+detailData.payment_type?detailData.deposit:detailData.jiage}}
                </span>
                <span class="tag f12">{{activityName(detailData)}}</span>
              </p>
              <p>
                <span
                  v-if="detailData.type===2&&detailData.userid&&!getLoadSettingStatus.data.is_delivery_flag&&!detailData.is_view"
                >
                  <del>
                    <template>{{showprice(detailData.shanchu_price)}}</template>
                    {{detailData.shanchu_price}}
                  </del>
                </span>
                <span v-else-if="detailData.type===8&&+detailData.payment_type">
                  预售价
                  <template>{{showprice(detailData.jiage)}}</template>
                  {{detailData.jiage}}
                </span>
                <!-- （秒杀进度条） -->
                <span
                  class="seckill-progress"
                  v-if="detailData.type==2&&+detailData.is_seckill&&detailData.userid&&!getLoadSettingStatus.data.is_delivery_flag&&!detailData.is_view"
                >
                  <span class="seckill-bg ml10">
                    <span class="progress-num" :style="{width:detailData.sale_percent+'%'}"></span>
                  </span>
                  <span class="seckill-robbed ml10">已抢{{detailData.sale_percent}}%</span>
                </span>
              </p>
            </div>
            <div class="gift-title-right">
              <p class="mb3">距离活动结束:</p>
              <p v-if="detailData.countDown">
                <span style="margin:0">{{detailData.countDown.d}}</span>
                <b>:</b>
                <span>{{detailData.countDown.h}}</span>
                <b>:</b>
                <span>{{detailData.countDown.m}}</span>
                <b>:</b>
                <span>{{detailData.countDown.s}}</span>
              </p>
            </div>
          </div>
          <!-- 普通商品 -->
          <div class="f18 general-title">
            <p v-if="!showActivityTxt(detailData)" class="general-price">
              <span class="f15" v-if="!detailData.userid">会员可见</span>
              <span class="f15" v-else-if="detailData.is_view">区域经销</span>
              <span class="f15" v-else-if="getLoadSettingStatus.data.is_delivery_flag">配送价</span>
              <span class="f15" v-else-if="detailData.type==6">{{detailData.jiage+'积分'}}</span>
              <span class="f15" v-else-if="detailData.is_bargain === 1 && detailData.tag === 2">议价商品</span>
              <span v-else>
                <span class="f12">￥</span>
                {{detailData.jiage}}
              </span>
            </p>
            <p
              class="f10"
              style="color:#777777"
              v-if="detailData.discount_prices&&detailData.userid&&detailData.type!==6"
            >
              折后价：
              <template>{{showprice(detailData.discount_prices)}}</template>
              {{detailData.discount_prices}}
              <cc-svg-icon
                icon-class="tips"
                class-name="tips ml5"
                size=".18rem"
                color="#999"
                @click="showDiscounted=true"
              ></cc-svg-icon>
            </p>
            <p class="general_name" v-if="detailData.general_name">
              <span
                class="f15 mr10"
                style="color:#333333;line-height: 0.31rem"
              >{{detailData.general_name}}</span>
              <!-- 商品标签-->
              <span class="lab" v-if="detailData.tag_arr&&detailData.tag_arr.length">
                <template v-for="(item,index) in detailData.tag_arr">
                  <span
                    :style="{'color':item.color,'border':'1px solid'+item.color}"
                    v-if="index < 3"
                    :key="index"
                  >{{item.name}}</span>
                </template>
              </span>
            </p>
            <p class="f12 goods-description" v-if="detailData.tips">{{detailData.tips}}</p>
          </div>
          <!-- 商品普通信息 -->
          <div class="goods-info">
            <div
              class="activity-rules"
              v-if="detailData.type==8||(detailData.activity_content?detailData.activity_content.constructor !==Array:0)"
              @click="promotionDetail()"
            >
              <div class="activity-rules-txt pt3">促销</div>
              <!-- 预售 采满 活动 促销 -->
              <!-- 预售 -->
              <div class="activity-rules-content">
                <div class="activity-rules-content-top">
                  <p v-if="detailData.userid==0">会员可见</p>
                  <div
                    class="box-left"
                    v-else
                    :style="{'width':detailData.type==8?'0.3rem':'0.6rem'}"
                  >
                    <!-- 预售 -->
                    <p v-if="detailData.type===8">
                      <span class="activity-tag">预售</span>
                    </p>
                    <!-- 优惠券、特价/秒杀、满赠、套餐、全场促销、活动（商品活动内容）  -->
                    <template v-if="detailData.activity_content">
                      <p
                        v-if="detailData.activity_content.coupon_info&&detailData.activity_content.coupon_info.display_coupon_arr.length"
                      >
                        <span class="activity-tag">优惠券</span>
                      </p>
                      <p v-if="detailData.activity_content.special_info">
                        <span class="activity-tag">{{+detailData.is_seckill?'秒杀':'特价'}}</span>
                      </p>
                      <p v-if="detailData.activity_content.gifts_introduc">
                        <span class="activity-tag">满赠</span>
                      </p>
                      <p v-if="detailData.type===3">
                        <span class="activity-tag">套装</span>
                      </p>
                      <p v-if="detailData.activity_content.point_info">
                        <span class="activity-tag">单品积分</span>
                      </p>
                      <p
                        v-if="detailData.activity_content.full_promotion_info&&detailData.activity_content.full_promotion_info.promotionway_detail_more"
                      >
                        <span class="activity-tag">全场促销</span>
                      </p>
                      <p v-if="detailData.activity_content.activity_introduc">
                        <span class="activity-tag">活动</span>
                      </p>
                    </template>
                  </div>
                  <div class="box-right">
                    <template v-if="detailData.userid">
                      <!-- 预售 -->
                      <p
                        style="line-height:0.17rem;width:3rem;"
                        class="mt3"
                        v-if="detailData.type===8"
                      >
                        <span v-if="+detailData.payment_type">
                          尾款：
                          <span v-if="getLoadSettingStatus.data.is_delivery_flag" class="f12">配送价</span>
                          <span v-else-if="detailData.is_view" class="f12">区域经销</span>
                          <span v-else class="f12">
                            <template>{{showprice (detailData.jiage-detailData.deposit)}}</template>
                            {{float_change(detailData.jiage-detailData.deposit)}}
                          </span>
                        </span>
                        <span v-else>
                          全款：
                          <span class="f12">
                            <template>{{showprice (detailData.jiage)}}</template>
                            {{detailData.jiage}}
                            <span>(该商品仅支持全款支付)</span>
                          </span>
                        </span>
                      </p>
                      <!-- 优惠券 -->
                      <template v-if="detailData.activity_content">
                        <p
                          v-if="detailData.activity_content.coupon_info&&detailData.activity_content.coupon_info.display_coupon_arr.length"
                        >
                          <span
                            v-for="item in detailData.activity_content.coupon_info.display_coupon_arr"
                            :key="item"
                            class="collect-coupons"
                          >{{item}}</span>
                        </p>
                        <!-- 特价/秒杀 -->
                        <p
                          v-if="detailData.activity_content.special_info"
                        >{{detailData.activity_content.special_info}}</p>
                        <!-- 满赠 -->
                        <p
                          v-if="detailData.activity_content.gifts_introduc"
                        >{{detailData.activity_content.gifts_introduc}}</p>
                        <!-- 套餐 -->
                        <p v-if="detailData.type===3">套装组合购买更优惠，去抢购</p>
                        <!-- 单品积分 -->
                        <p
                          v-if="detailData.activity_content.point_info"
                        >{{detailData.activity_content.point_info[detailData.id]}}</p>
                        <!-- 全场促销 -->
                        <p
                          v-if="detailData.activity_content.full_promotion_info&&detailData.activity_content.full_promotion_info.promotionway_detail_more"
                        >{{detailData.activity_content.full_promotion_info.promotionway_detail_more}}</p>
                        <!-- 活动 -->
                        <p
                          v-if="detailData.activity_content.activity_introduc"
                        >{{detailData.activity_content.activity_introduc}}</p>
                      </template>
                    </template>
                  </div>
                  <cc-svg-icon
                    icon-class="right-arrow"
                    class-name="right-arrow"
                    size=".2rem"
                    color="#B8B5B5"
                    v-if="detailData.type!==8"
                  ></cc-svg-icon>
                </div>
                <!-- 预售规则 -->
                <div v-if="detailData.type==8">
                  <div
                    class="activity-rules-content-bottom"
                    v-if="+detailData.payment_type"
                  >付尾款：{{detailData.payment_start_time_format+'~'+detailData.payment_end_time_format}}</div>
                  <div class="activity-rules-content-bottom">
                    <p>预计发货时间：{{detailData.delivery_time_format}}</p>
                  </div>
                  <div class="activity-rules-content-bottom">
                    <span>流程：</span>
                    <span>
                      1.支付定金；
                      {{+detailData.payment_type?'2.支付尾款；3.发货':'2.发货'}}
                      <cc-svg-icon
                        icon-class="tips"
                        class-name="tips"
                        size=".18rem"
                        @click.stop="isPresellPopup = true"
                      ></cc-svg-icon>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="box1"
              style="border-radius:.1rem .1rem 0 0"
              @click.stop="cartBtn(detailData,cartIconColor(detailData)?1:0,1)"
            >
              <span class="goods-info-title goods-info1">
                已选规格
                <span class="goods-info-right">
                  <span class="goods-info-txt ml20">{{detailData.norms}}</span>
                  <!-- (首次默认选中 ) -->
                  <span class="goods-info-txt ml5">{{batchTxt?batchTxt:detailData.batch_code}}</span>
                </span>
              </span>
              <cc-svg-icon
                icon-class="right-arrow"
                class-name="right-arrow"
                size=".2rem"
                color="#B8B5B5"
              ></cc-svg-icon>
            </div>
            <div class="box1" v-if="detailData.delivery_date">
              <span class="goods-info-title">
                预计到货
                <span class="goods-info-txt ml20">{{detailData.delivery_date}}</span>
              </span>
            </div>
            <div class="box1 goods-message" @click="Message()" v-if="detailData.userid">
              <span class="goods-info-title">商品留言</span>
              <cc-svg-icon
                icon-class="right-arrow"
                class-name="right-arrow"
                color="#B8B5B5"
                size=".2rem"
              ></cc-svg-icon>
            </div>
            <div class="box2">
              <div>
                <span class="goods-info-title">厂家</span>
                <span class="goods-info-txt">{{detailData.produce_unit}}</span>
              </div>
              <div>
                <span class="goods-info-title">分类</span>
                <span
                  class="goods-info-txt"
                  v-if="detailData.parent_category_name"
                >{{detailData.parent_category_name+'>'+detailData.category_name}}</span>
              </div>
              <div>
                <span class="goods-info-title">商品名</span>
                <span class="goods-info-txt">{{detailData.product_name}}</span>
              </div>
              <div>
                <span class="goods-info-title">商品编码</span>
                <span class="goods-info-txt">{{detailData.product_code}}</span>
              </div>
              <div>
                <span class="goods-info-title">生产日期</span>
                <span class="goods-info-txt">{{detailData.product_date}}</span>
              </div>
              <div>
                <span class="goods-info-title">有效日期</span>
                <span class="goods-info-txt">{{detailData.last_date}}</span>
              </div>
              <div>
                <span class="goods-info-title">批准文号</span>
                <span class="goods-info-txt">{{detailData.license}}</span>
              </div>
              <div style="border-radius: 0 0 .1rem .1rem" v-if="detailData.type!==6">
                <span class="goods-info-title">建议零售价</span>
                <span class="goods-info-txt" v-if="detailData.retail_price">
                  <template>{{showprice(detailData.retail_price)}}</template>
                  {{detailData.retail_price}}
                </span>
              </div>
            </div>
          </div>
          <!-- 商品详细介绍 -->
          <div class="goods-details-info">
            <van-tabs v-model="active" background="#F5F5F5" :line-width="30">
              <van-tab title="商品说明书">
                <no-info
                  v-if="detailData.manual==''||detailData.manual==null"
                  txt=" 抱歉，本产品的商品说明书尚在整理中"
                ></no-info>
                <div class="instructions" v-else>
                  <div v-html="detailData.manual"></div>
                </div>
              </van-tab>
              <van-tab title="产品介绍">
                <no-info v-if="detailData.introduc==''" txt=" 抱歉，本产品的产品介绍尚在整理中..."></no-info>
                <div class="instructions" v-else v-html="detailData.introduc"></div>
              </van-tab>
              <van-tab title="药检资料">
                <no-info txt="如需下载药检资料，请移步到电脑端操作"></no-info>
              </van-tab>
            </van-tabs>
          </div>
          <!-- 猜你喜欢 -->
          <div class="like">
            <p class="like-tit">猜你喜欢</p>
            <div class="like-goods">
              <!-- 暂无推荐商品 -->
              <div class="no-like-goods" v-if="!recommendGood.length">
                <img src="./../../assets/img/not-goods.png" alt />
                <p>亲，暂无推荐商品哦</p>
              </div>
              <div v-else>
                <div
                  class="like-goods-list"
                  v-for="(item,index) in recommendGood"
                  :key="index"
                  @click="gotoDetail(item)"
                >
                  <div class="like-goods-list-img">
                    <!-- 懒加载的图片 -->
                    <img :src="item.image" />
                  </div>
                  <p class="like-name">
                    <span>{{item.general_name}}</span>
                    <span class="ml5">{{item.norms}}</span>
                  </p>
                  <p class="like-produce">{{item.produce_unit}}</p>
                  <p class="like-price">
                    <span class="mt5" style="display:inline-block">
                      <span class="f12">{{showprice (item.jiage)}}</span>
                      <span class="f18">{{item.jiage}}</span>
                    </span>
                    <cc-svg-icon
                      size="24px"
                      icon-class="shop-cart"
                      class="shopCartIcon"
                      @click.stop="cartBtn(item,cartIconColor(item)?1:0)"
                    ></cc-svg-icon>
                  </p>
                  <!-- 活动标识-->
                  <i
                    class="xpt-icons"
                    :class="{
                          'xpt-icons__manzeng': item.type == 5,
                          'xpt-icons__huodong': item.type == 4,
                          'xpt-icons__cuxiao': item.type == 3 && !item.is_bargain,
                          'xpt-icons__tejia': item.type == 2 && +item.is_seckill ===0,
                          'xpt-icons__miaosha': item.type == 2 && +item.is_seckill ===1,
                        }"
                  ></i>
                  <!-- 全场促销 -->
                  <i class="qccx_img" v-if="item.is_enjoy_promotion"></i>
                </div>
              </div>
            </div>
          </div>
        </cc-pull-refresh>
      </cc-main>
      <cc-small-nav v-model="isShowSmallNav" />
      <!-- 预售说明弹窗 -->
      <!-- getContainer="body" -->
      <presell-explain :isShowPopup="isPresellPopup" @close="isPresellPopup=false"></presell-explain>
      <!-- 促销的弹窗 -->
      <cc-bottom-popup
        title="促销"
        getContainer="body"
        :height="556"
        @close="promotionShow=false"
        :showBtn="false"
        :isShowPopup="promotionShow"
      >
        <div class="promotionAlert" v-if="detailData.activity_content">
          <!-- 特价/秒杀 -->
          <div class="content" v-if="
        detailData.activity_content.special_info">
            <div class="content-left">
              <span class="activity-tag">{{+detailData.is_seckill?'秒杀':'特价'}}</span>
            </div>
            <div class="content-right">
              <p>{{detailData.activity_content.special_info}}</p>
            </div>
          </div>
          <!-- 满赠 -->
          <div
            class="content giftAlert"
            v-if="
        detailData.activity_content.gifts_introduc"
            @click="toGiftDetail()"
          >
            <div class="content-left">
              <span class="activity-tag">满赠</span>
            </div>
            <div class="content-right">
              <p>{{detailData.activity_content.gifts_introduc}}</p>
            </div>
            <cc-svg-icon
              icon-class="right-arrow"
              class-name="right-arrow"
              size=".2rem"
              color="#B8B5B5"
            ></cc-svg-icon>
          </div>
          <!-- 套装-->
          <div
            class="content giftAlert"
            v-if="detailData.type===3"
            @click="goPromotion(detailData.for_id)"
          >
            <div class="content-left">
              <span class="activity-tag">套装</span>
            </div>
            <div class="content-right">
              <p>套装组合购买更优惠，去抢购</p>
            </div>
            <!--弹套装的弹窗-->
            <cc-svg-icon
              icon-class="right-arrow"
              class-name="right-arrow"
              color="#B8B5B5"
              size=".2rem"
            ></cc-svg-icon>
          </div>
          <!-- 单品积分-->
          <div class="content" v-if="detailData.activity_content.point_info">
            <div class="content-left">
              <span class="activity-tag">单品积分</span>
            </div>
            <div class="content-right">
              <p>{{detailData.activity_content.point_info[detailData.id]}}</p>
            </div>
          </div>
          <!-- 全场促销-->
          <div class="content" v-if="detailData.activity_content.full_promotion_info">
            <div class="content-left">
              <span class="activity-tag">全场促销</span>
            </div>
            <div class="content-right">
              <p>{{detailData.activity_content.full_promotion_info.promotionway_detail_more}}</p>
            </div>
          </div>
          <!-- 活动-->
          <div class="content" v-if="detailData.activity_content.activity_introduc">
            <div class="content-left">
              <span class="activity-tag">活动</span>
            </div>
            <div class="content-right">
              <p>{{detailData.activity_content.activity_introduc}}</p>
            </div>
          </div>

          <div class="coupon" v-if="detailData.activity_content">
            <div
              class="coupons-available mt20"
              v-if="detailData.activity_content.coupon_info&&detailData.activity_content.coupon_info.get_coupon_list.length"
            >
              <!-- （立即领取 拿领券中心的接口,领券中心重构，再换回来）-->
              <p class="f14">可领取优惠券</p>
              <div
                class="coupon-list mb10"
                v-for="(item,index) in detailData.activity_content.coupon_info.get_coupon_list"
                :key="index"
              >
                <div
                  class="coupon-list-left"
                  :class="item.coupon_type==1? 'coupon_red':'coupon_blue'"
                >
                  <p v-if="item.coupon_type==1">
                    ￥
                    <span style="font-size:26px;">{{item.reduce_money}}</span>
                  </p>
                  <p v-if="item.coupon_type==2">
                    <span style="font-size:26px;">{{item.discount}}折</span>
                  </p>
                  <p>满{{item.full_amount}}可用</p>
                </div>
                <div class="coupon-list-right">
                  <img v-if="item.show" src="./../../assets/img/coupon-received.png" alt />
                  <p style="font-weight:bold;">{{item.tips}}</p>
                  <p>{{item.start_time+'-'+item.end_time}}</p>
                  <div class="btn">
                    <p class="get-btn" v-if="!item.show" @click="getcoupon(item)">立即领取</p>
                    <p class="use-btn" v-else @click="useCoupon(item.get_id)">可用商品</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="coupon-received mt20"
              v-if="detailData.activity_content.coupon_info&&detailData.activity_content.coupon_info.my_unused_list.length"
            >
              <p class="f14">已领取优惠券</p>
              <div
                class="coupon-list mb10"
                v-for="(item,index) in detailData.activity_content.coupon_info.my_unused_list"
                :key="index"
              >
                <div
                  class="coupon-list-left"
                  :class="item.coupon_type==1? 'coupon_red':'coupon_blue'"
                >
                  <p v-if="item.coupon_type==1">
                    ￥
                    <span style="font-size:26px;">{{item.reduce_money}}</span>
                  </p>
                  <p v-if="item.coupon_type==2">{{item.discount}}折</p>
                  <p>满{{item.full_amount}}可用</p>
                </div>
                <div class="coupon-list-right">
                  <p style="font-weight:bold;">{{item.tips}}</p>
                  <p>{{item.start_time+'-'+item.end_time}}</p>
                  <div class="btn">
                    <p class="use-btn" @click="useCoupon(item.get_id)">可用商品</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </cc-bottom-popup>
      <!-- 折后价弹窗start -->
      <cc-bottom-popup
        title="折后价说明"
        getContainer="body"
        :height="370"
        @close="showDiscounted=false"
        :showBtn="false"
        :isShowPopup="showDiscounted"
      >
        <div class="discounted-box">
          <p>折后价指达到全场促销条件后的最优购买单价，折后价仅供参考，计算可能存在细微误差。</p>
          <p style="color:#EE1717;">
            <span>折后价：</span>
            <span>
              <template v-if="!isNaN(detailData.discount_prices)">￥</template>
              {{detailData.discount_prices}}</span>
          </p>
          <p>
            <span>商品原价：</span>
            <span>
            <template v-if="!isNaN(detailData.jiage)">￥</template>
              {{detailData.jiage}}</span>
          </p>
        </div>
      </cc-bottom-popup>
      <!-- 折后价弹窗end -->
      <!-- 图片全屏弹窗 -->
      <van-image-preview class="full-screen-img" v-model="showimg" :images="detailData.image" @change="onChangeimg" :start-position="indeximg">
        <template v-slot:index>
          <div class="imgpreview">
            <span class="ml10">{{indeximg+1}}/{{detailData.image.length}}</span>
            <span class="mr10" @click="showimg=false">
              <van-icon name="cross" color="#fff" />
            </span>
          </div>
        </template>
      </van-image-preview>
      <!-- 图片全屏弹窗 -->
      <!-- 普通商品-->
      <div
        class="nogoodtxt"
        v-if="getLoginStatus.data.member_id&&((detailData.goodsstock==0&&detailData.type!==8&&getLoadSettingStatus.data.is_empty_stock === 0)||(detailData.type==8&&+detailData.presell_stock==0))"
      >商品暂时缺货，商家正在备货中</div>
      <cc-footer class="footer">
        <div class="footernav">
          <div class="left">
            <div @click="fav()">
              <cc-svg-icon
                :icon-class="favShow?'colected': 'collec'"
                class-name="collec"
                :size="favShow?'.18rem':'.2rem'"
                :style="{'paddingBottom':favShow?'2px':'0px'}"
              ></cc-svg-icon>
              <span>{{favShow?'已收藏':'收藏'}}</span>
            </div>
            <div @click="gotocart()">
              <cc-svg-icon icon-class="detail-buycar" class-name="detail-buycar" size=".2rem"></cc-svg-icon>
              <span>采购车</span>
            </div>
          </div>
          <div class="right" v-if="detailData.type">
            <!-- 区域经销 -->
            <p class="bugBtn1" v-if="detailData.is_view" @click.stop="cartBtn(detailData)">申请采购</p>
            <p
              @click.stop="cartBtn(detailData,cartIconColor(detailData)?1:0)"
              class="f15"
              v-else-if="detailData.type===8"
              :class="getLoginStatus.data.member_id&&detailData.type==8&&+detailData.presell_stock==0?'bugBtn3':'bugBtn2'"
            >支付定金</p>
            <!-- 议价商品 -->
            <p
              class="bugBtn1"
              v-else-if="detailData.is_bargain === 1 && detailData.tag === 2&&detailData.type!==6"
              @click.stop="cartBtn(detailData)"
            >申请采购</p>
            <!-- 缺货 -->
            <p
              class="bugBtn1"
              v-else-if="(detailData.goodsstock==0&&detailData.type!==8&& getLoadSettingStatus.data.is_empty_stock === 0)||(detailData.type==8&&detailData.presell_stock==0)"
              @click.stop="cartBtn(detailData,cartIconColor(detailData)?1:0)"
            >我要预订</p>
            <p
              class="bugBtn2"
              v-else
              @click.stop="cartBtn(detailData,cartIconColor(detailData)?1:0)"
            >加入采购车</p>
          </div>
        </div>
      </cc-footer>

      <!-- 购物车弹窗start(有库存) -->
        <cc-shop-cart
          :isShowPopup="showcart"
          :cartItemData="cartItem"
          @close="showcart=false"
          @batchVal="batchVal"
          :height="556"
          :HeaderHight="88"
          :resetval="true"
          ref="shopCart"
        ></cc-shop-cart>
      <!-- 购物车弹窗end -->
      <!-- 缺货弹窗start-->
        <cc-nogoods-remind
          :isShowPopup="shownogoods"
          :cartItem="cartItem"
          :height="426"
          @close="shownogoods=false"
          ref="nogoods"
        ></cc-nogoods-remind>
      <!-- 缺货弹窗end -->
      <!-- 促销套餐详情start -->
      <cc-promot-cart
        :isShowPopup="showCartPromot"
        :promotCartData="promotCartData"
        :height="556"
        @close="showCartPromot=false"
        v-if="showCartPromot"
        class="promot-cart"
      ></cc-promot-cart>
      <!-- 促销套餐详情end -->
    </template>
  </cc-container>
</template>
<script>
import Vue from 'vue'
import {
  Icon,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Toast,
  ImagePreview
} from 'vant'
import noInfo from './components/no-info.vue'
import presellExplain from './../shopping-cart/purchase/presell-explain.vue'
import Skeleton from './skeleton.vue'

import {
  loadDetailInfo,
  recommendGoods,
  getcouponGet,
  Addfavone
} from './../../fetch/goods-details/index.js'
import Command from '@/mixins/command'
import cartStep from '@/mixins/cartStep'
import CountDownMixin from './../../mixins/countDown'

Vue.use(Icon)
  .use(Swipe)
  .use(SwipeItem)
  .use(Tab)
  .use(Tabs)
  .use(Toast)
  .use(ImagePreview)
export default {
  mixins: [Command, cartStep, CountDownMixin],
  components: {
    noInfo,
    presellExplain,
    Skeleton
  },
  data () {
    return {
      indeximg: 1,
      showimg: false,
      showDiscounted: false,
      showSkeleton: true,
      isShowSmallNav: false,
      current: 0,
      active: 0,
      // 促销商品弹窗
      promotionShow: false,
      isPresellPopup: false, // 预售说明弹窗
      activeTitle: 0,
      detailData: '',
      topTitleCon: [
        {
          id: 0,
          txt: '商品'
        },
        {
          id: 1,
          txt: '详情'
        },
        {
          id: 2,
          txt: '推荐'
        }
      ],
      // 猜你喜欢的数据
      recommendGood: '',
      // 收藏显示
      favShow: false,
      // 促销套餐数据
      promotCartData: '', // 促销套餐加入购物车开关
      showCartPromot: false,
      cartData: '',
      // 下拉刷新开关
      isLoading: false,
      disabled: false
    }
  },
  computed: {
    activityName () {
      return function (item) {
        if (item.type === 2) {
          return +item.is_seckill ? '限时秒杀' : '限时特价'
        } else if (item.type === 5) {
          return '采满有赠'
        } else if (item.type === 8) {
          return +item.payment_type ? '定金' : '预售'
        } else {
          return ''
        }
      }
    },
    showActivityTxt () {
      return function (item) {
        if (item.type === 2 || item.type === 5 || item.type === 8) {
          return true
        } else {
          return false
        }
      }
    },
    showprice () {
      return function (num) {
        return isNaN(num) ? '' : '￥'
      }
    }
  },
  async created () {
    this.loadData(this.$route.query)
  },
  methods: {
    /**
     * 顶部栏滚动
     */
    scroll () {
      this.$nextTick(() => {
        this.$refs.contain.$el.onscroll = e => {
          var ele = document.getElementsByClassName('topTitle')[0]
          var header = document.getElementsByClassName('header')[0]
          var detail = document.getElementsByClassName('goods-details-info')[0]
          var like = document.getElementsByClassName('like')[0]
          ele.style.opacity = e.target.scrollTop / 300
          if (ele.style.opacity > 0) {
            header.style.background =
              'rgba(245, 245, 245, ' + e.target.scrollTop / 300 + ')'
          } else {
            header.style.backgroundColor = '#fff'
          }
          if (
            e.target.scrollTop >= 0 &&
            e.target.scrollTop <
              detail.offsetTop
          ) {
            this.activeTitle = 0
          } else if (
            e.target.scrollTop >=
              detail.offsetTop &&
            e.target.scrollTop < like.offsetTop
          ) {
            this.activeTitle = 1
          } else if (
            e.target.scrollTop >=
            like.offsetTop
          ) {
            this.activeTitle = 2
          }
        }
      })
    },
    /**
     * 下拉刷新
     */
    onRefresh () {
      this.loadData(this.$route.query)
    },
    batchVal (msg) {
      this.batchTxt = msg
    },
    judgeTime (item) {
      return parseInt(+item.end_time - +item.now_time)
    },
    async loadData (params) {
      let obj = {
        goods_id: params.goods_id,
        type: params.type
      }
      await loadDetailInfo(obj).then(res => {
        this.$tips(res, { tip: false }, res => {
          this.showSkeleton = false
          // 顶部栏滚动
          this.scroll()
          this.detailData = res.goods_detail_arr
          if (this.detailData.is_view) {
            if (this.detailData.type === 8 && +this.detailData.payment_type) {
              this.detailData.deposit = '区域经销'
            }
            this.detailData.jiage = '区域经销'
            this.$set(this.detailData, 'retail_price', '区域经销')
            if (this.detailData.discount_prices) {
              this.detailData.discount_prices = '区域经销'
            }
          } else if (this.getLoadSettingStatus.data.is_delivery_flag) {
            if (this.detailData.type === 8 && +this.detailData.payment_type) {
              this.detailData.deposit = '配送价'
            }
            this.$set(this.detailData, 'jiage', '配送价')
            this.$set(this.detailData, 'retail_price', '配送价')
            this.$set(this.detailData, 'shanchu_price', '配送价')
          } else if (
            this.detailData.is_bargain === 1 &&
            this.detailData.tag === 2
          ) {
            this.$set(this.detailData, 'retail_price', '议价商品')
            // this.$set(this.detailData, 'jiage', '议价商品')
            this.$set(this.detailData, 'discount_prices', '议价商品')
          }
          this.cartData = this.detailData
          this.favShow = this.detailData.fav
          this.$set(this.detailData, 'countDown', {
            d: '',
            h: '',
            m: '',
            s: ''
          })
          this.countDown(this.detailData)
        })
        if (
          this.detailData.coupon_info &&
          this.detailData.coupon_info.get_coupon_list
        ) {
          this.detailData.coupon_info.get_coupon_list.map((item, index) => {
            this.$set(item, 'show', false)
          })
        }
        this.isLoading = false
        this.recommendGoodsData(
          res.data.goods_detail_arr.category_id,
          res.data.goods_detail_arr.id
        )
      })
    },
    async recommendGoodsData (id, goodid) {
      let { data } = await recommendGoods({
        category_id: id,
        goods_id: goodid
      })
      this.recommendGood = data.recommend_goods
      this.recommendGood.map(item => {
        if (item.is_view) {
          item.jiage = '区域经销'
        } else if (this.getLoadSettingStatus.data.is_delivery_flag) {
          item.jiage = '配送价'
        }
      })
    },
    getElementToPageTop (el) {
      if (el.parentElement) {
        return this.getElementToPageTop(el.parentElement) + el.offsetTop
      }
      return el.offsetTop
    },
    tabTop (index) {
      this.activeTitle = index
      var detail = document.getElementsByClassName('goods-details-info')[0]
      var like = document.getElementsByClassName('like')[0]
      this.$nextTick(() => {
        this.$refs.contain.$el.scrollTop =
          index === 0
            ? 0
            : index === 1
              ? detail.offsetTop
              : like.offsetTop
      })
    },
    onChange (index) {
      this.current = index
    },
    Message () {
      this.$router.push({
        path: '/goods-message',
        query: { product_code: this.detailData.product_code }
      })
    },
    toGiftDetail () {
      this.$router.push({
        path: '/gift-detail',
        query: { for_id: this.detailData.for_id }
      })
    },
    gotocart () {
      this.$router.push({ path: 'shopping-cart/purchase' })
    },
    gotoDetail (item) {
      this.$router.push({
        path: '/goods-details',
        query: {
          goods_id: item.id,
          type: item.type,
          category_id: item.category_id
        }
      })
    },
    async fav () {
      let res = await Addfavone({ goods_id: this.detailData.id })
      if (res.status === 0) {
        this.favShow = !this.favShow
        Toast(res.info.msg)
      }
    },
    showimgs (index) {
      this.showimg = true
      this.indeximg = index
    },
    onChangeimg (index) {
      this.indeximg = index
    },
    /**
     *  点击购物车购买
     */
    cartBtn (item, cartColor, noAlert) {
      this.cartBtnAlter(item, cartColor, noAlert)
    },
    async getcoupon (item) {
      let res = await getcouponGet({ id: item.id })
      item.show = true
      Toast(res.msg)
      this.$set(item, 'get_id', res.data.get_id)
    },
    useCoupon (id) {
      this.$router.push({
        path: '/categorylist',
        query: { get_coupon_id: id }
      })
    },
    promotionDetail () {
      if (!this.detailData.userid || this.detailData.type === 8) {
        return false
      }
      this.promotionShow = true
    }
  }
}
</script>
<style lang='scss' scoped>
.goods-info1 {
  @include ell(1);
}
.activity-tag {
  padding: 2px 3px;
  font-size: 10px;
  background: #fce0e0;
  color: #fb5470;
  border-radius: 2px;
  line-height: 14px;
}
.promot-cart {
  position: relative;
  z-index: 1002;
}
.ellipsis {
  width: 50%;
  height: 100%;
  @include center();
  transform: translateX(-5px);
  &-icon {
    transform: rotate(90deg);
  }
}
.header {
  /deep/ {
    background: #fff;
    color: #535353;
    .left-arrow {
      color: #535353 !important;
    }
  }
}
.topTitle {
  width: 200px;
  height: 38px;
  display: flex;
  justify-content: space-around;
  span {
    font-size: 16px;
    color: #333333;
  }
  span.activeTitle {
    border-bottom: 2px solid var(--APP_theme_color);
    color: var(--APP_theme_color);
  }
}
.custom-indicator {
  position: absolute;
  right: 12px;
  bottom: 15px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  bottom: 0.25rem;
}
.main {
  .gift-title {
    height: 51px;
    width: 100%;
    display: flex;
    color: #fff;
    &-left {
      width: 250px;
      background: url("./../../assets/img/detail-txt.png") no-repeat;
      background-size: 100% 100%;
      .tag {
        color: #fb5470;
        height: 17px;
        padding: 0 6.5px;
        line-height: 17px;
        background: #fff;
        border-radius: 7.5px;
      }
      p:nth-child(1) {
        height: 30px;
        display: flex;
        align-items: center;
      }
      > p > span {
        margin-left: 10px;
      }
    }
    &-right {
      text-align: center;
      width: 125px;
      background: hsl(36, 86%, 86%);
      p:nth-child(1) {
        color: #fb5470;
        margin-top: 6px;
      }
      p:nth-child(2) {
        span {
          display: inline-block;
          padding: 2px 2.5px;
          background: #fb5470;
          text-align: center;
          border-radius: 2px;
          margin-left: 3px;
        }
        b {
          color: #fb5470;
          margin-left: 3px;
          font-weight: bold;
        }
      }
    }
  }
  .general-title {
    margin-left: 10px;
    background: #f5f5f5;
    color: #f44e4e;
    padding: 7px 0 7px 0;
    // .general_name {
    //   line-height: 31px;
    // }
    .general-price {
      height: 26px;
      line-height: 26px;
    }
    .lab {
      display: inline-block;
      margin-bottom: 5px;
      span {
        padding: 2px 4.5px;
        border-radius: 9.5px;
        font-size: 10px;
        margin-right: 10px;
      }
    }
  }
  .goods-info {
    border-radius: 10px;
    background: #fff;
    font-size: 12px;
    .collect-coupons {
      color: #e61e3f;
      background: url("./../../assets/img/coupon-border.png") no-repeat;
      background-size: 100% 100%;
      margin-right: 4px;
      font-size: 10px;
      padding: 3px 7px;
    }

    .activity-rules {
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      padding: 10px 10px 0 10px;
      border-bottom: 2px solid #f5f5f5;
      &-txt {
        width: 63px;
        color: #999999;
      }
      &-content {
        position: relative;
        width: 280px;
        .right-arrow {
          position: absolute;
          top: 0;
          right: -2px;
        }
        p {
          line-height: 27px;
          height: 27px;
          @include ell(1);
          width: 200px;
        }
        &-top,
        &-bottom {
          margin-bottom: 5px;
        }
        &-top {
          display: flex;
          .box-left {
            display: inline-block;
            margin-right: 10px;
          }
          .box-right {
            @include ell(1);
          }
        }
        &-bottom {
          display: flex;
        }
      }
    }
    .box1,
    .box2 > div {
      display: flex;
      align-items: center;
      padding: 0 10px;
    }
    .box1 {
      border-bottom: 2px solid #f5f5f5;
      height: 45px;
      display: flex;
      justify-content: space-between;
    }
    .box2 > div {
      height: 26px;
    }
    &-title {
      color: #999999;
      margin-right: 15px;
    }
    &-txt {
      color: #333333;
    }
    .box2 {
      padding: 7px 0;
      .goods-info-title {
        display: inline-block;
        width: 60px;
      }
      .goods-info-txt {
        display: inline-block;
        width: 280px;
        @include ell(1);
      }
    }
  }
  .goods-details-info {
    .fb {
      font-weight: bold;
    }
    .instructions {
      background: #fff;
      margin: 0 10px;
      border-radius: 10px;
      padding: 12px;
      box-sizing: border-box;
      line-height: 24px;
    }
  }
  .swipe {
    .tips {
      position: absolute;
      bottom: 0;
      left: 0;
      color: #777777;
      font-size: 10px;
      height: 25px;
      width: 100%;
      @include center();
      background: #fff;
      opacity: 0.8;
    }
    .swipe-item {
      position: relative;
      @include center();
      background: #fff;
      img {
        width: 240px;
        height: 210px;
      }
      // p {
      //   color: #777777;
      //   font-size: 10px;
      //   height: 25px;
      //   width: 100%;
      //   @include center();
      // }
      span {
        position: absolute;
        right: 0.65rem;
        bottom: 0.25rem;
        display: inline-block;
        width: 49px;
        height: 49px;
        background: url("./../../assets/img/special-goods.png") no-repeat;
      }
    }
  }
  // 猜你喜欢
  .like {
    margin: 0 10px;
    &-tit {
      font-weight: bold;
      font-size: 15px;
      line-height: 55px;
    }
    &-goods {
      width: 100%;
      border-radius: 10px;
      margin-bottom: 10px;
      overflow: hidden;
      .no-like-goods {
        width: 355px;
        height: 215px;
        background: #fff;
        display: flex;
        @include center();
        img {
          width: 154px;
          height: 111px;
        }
        p {
          font-size: 12px;
          color: #555555;
          margin-top: 20px;
        }
      }
      > div > div:nth-child(odd) {
        margin-right: 5px;
      }
      &-list {
        background: #fff;
        width: 175px;
        display: flex;
        flex-direction: row;
        display: inline-block;
        margin-bottom: 5px;
        position: relative;
        &-img {
          height: 122px;
          width: 100%;
          @include center();
          img {
            width: 100px;
            height: 100px;
            border-radius: 4px;
          }
        }
        .xpt-icons {
          top: 11px;
          left: 38px;
        }
        .qccx_img {
          right: 36px;
          bottom: 76px;
        }
        p {
          font-size: 12px;
          line-height: 18px;
          height: 18px;
          margin: 0 10px;
          @include ell(1);
        }
        .like-name {
          color: #333333;
        }
        .like-produce {
          color: #777777;
        }
        .like-price {
          padding-top: 10px;
          box-sizing: border-box;
          height: 45px;
          color: #f63838;
        }
      }
    }
  }
}
.nogoodtxt {
  height: 30px;
  width: 100%;
  @include center();
  color: #fff;
  background: #aaaaaa;
  opacity: 0.9;
  font-size: 12px;
}
.footer {
  .footernav {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    .left,
    .right {
      width: 50%;
    }
    .left {
      display: flex;
      justify-content: space-around;
      div {
        font-size: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 36px;
        height: 36px;
      }
    }
    .right {
      p {
        height: 40px;
        width: 160px;
        border-radius: 20px;
        @include center();
      }
      .bugBtn1,.bugBtn2{
        border: 1px solid var(--APP_theme_color);
      }
      .bugBtn1 {
        color: var(--APP_theme_color);
        background: var(--APP_theme_color_colorOpacity1);
      }
      .bugBtn2 {
        color: #fff;
        background: var(--APP_theme_color);
      }
      .bugBtn3{
        color: #fff;
        background: #B5B5B5;
        border: 1px solid #B5B5B5;
      }
    }
  }
}
.promotionAlert {
  padding: 0 10px;
  position: relative;
  .content {
    line-height: 26px;
    font-size: 12px;
    color: #666666;
    display: flex;
    padding-top: 17px;
    padding: 17px 12px 0 0;
    .content-left {
      width: 72px;
    }
    .content-right {
      width: 300px;
    }
  }
  .giftAlert {
    position: relative;
    .right-arrow {
      position: absolute;
      top: 19px;
      right: 0px;
    }
  }
}
.coupon {
  > div > p {
    line-height: 29px;
    color: #999999;
  }
  .coupon-list {
    height: 90px;
    width: 100%;
    display: flex;
    > div {
      height: 90px;
    }
    .coupon_red {
      background: url("./../../assets/img/coupon/coupon_red.png") no-repeat;
      background-size: 100% 100%;
    }
    .coupon_blue {
      background: url("./../../assets/img/coupon/coupon_blue.png") no-repeat;
      background-size: 100% 100%;
    }
    &-left {
      color: #fff;
      font-size: 12px;
      height: 100%;
      width: 115px;
      @include center();
      flex-direction: column;
    }

    &-right {
      position: relative;
      width: 240px;
      // box-shadow: 0px 0px 8px #f4f4f4;
      box-shadow: 4px 4px 9px 0px rgba(242, 242, 242, 0.8),
        1px -5px 9px 0px rgba(242, 242, 242, 0.34);
      padding: 5px 0 0 12px;
      box-sizing: border-box;
      img {
        width: 42px;
        height: 32px;
        position: absolute;
        top: 0;
        right: 10px;
      }
      p:nth-child(1) {
        color: #333333;
      }
      p:nth-child(2) {
        color: #999999;
      }
      p {
        line-height: 21px;
      }
      .btn {
        display: flex;
        flex-direction: row-reverse;
        p {
          border: 1px solid var(--APP_theme_color);
          width: 65px;
          height: 23px;
          border-radius: 11.5px;
          @include center();
          margin-right: 22px;
        }
        .use-btn {
          color: var(--APP_theme_color);
          background: #fff;
        }
        .get-btn {
          color: #fff;
          background: var(--APP_theme_color);
        }
      }
    }
  }
}
.gift-goods {
  height: 125px;
  width: 100%;
  &-left {
    .img {
      width: 100px;
      height: 100px;
    }
  }
}
.custom-indicator {
  width: 35px;
  height: 18px;
  color: #fff;
  border-radius: 9px;
  padding: 0;
  @include center();
}
.goods-description {
  line-height: 18px;
  color: #777;
}
.goods-details-info {
  /deep/ {
    .van-tabs__line {
      bottom: 0.24rem;
      background-color: var(--APP_theme_color);
      height: 2px;
    }
  }
}
.seckill-progress {
  display: inline-block;
  .seckill-bg,
  .progress-num {
    display: inline-block;
    // border-radius: 25px;
    border-radius: 2.5px;
    overflow: hidden;
    line-height: 7px;
  }
  .seckill-bg {
    background: #fa7389;
    width: 70px;
    height: 5px;
    position: relative;
  }
  .progress-num {
    height: 100%;
    background: #fff;
    position: absolute;
    top: 0;
    bottom: 0;
  }
  .seckill-robbed {
    font-size: 10px;
    color: #fff;
  }
}
.discounted-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px 12px 0 12px;
  font-size: 12px;
  color: #343434;
  p:nth-child(1) {
    line-height: 22px;
  }
  p:nth-child(2),
  p:nth-child(3) {
    line-height: 42px;
    display: flex;
    justify-content: space-between;
  }
}
.imgpreview {
  width: 375px;
  height: 50px;
  display: flex;
  justify-content: space-between;
}
.full-screen-img{
  /deep/{
    .van-image-preview__image {
      width: 100%;
    }
  }
}
</style>
